/**
* file : TournamentRelated/List.jsx
* 설명 : 토너먼트 리스트
*/

import BtnPrev from "assets/images/btn_prev1.png"
import BtnNext from "assets/images/btn_next1.png"
import Evo from "assets/images/brand-icon-evo.png"
import Pragmatic from "assets/images/brand-icon-PRAGMATIC.png"
import Pg from "assets/images/brand-icon-pg.png"
import Bng from "assets/images/brand-icon-BNG.png"
import Netent from "assets/images/brand-icon-NETENT.png"
import Grand from "assets/images/brand-icon-grand.png"

import $ from 'jquery';
import { Link } from 'react-router-dom';
import { Fnc, Url } from 'common/globals';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Search } from "components/Common/ApiCall";

export default function List( props ) {
    // 이미지
  const imgs = [Evo, Pragmatic, Pg, Bng, Netent, Grand]
  // common 데이터
  const common = useSelector(state => state.Common);
  // 타이머
  const [ timer, setTimer ] = useState([]);
  // 데이터
  const [datas, setDatas] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(8)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 8
    setListCount(count);
  }
  // 조회 조건 
  const [searchWhere, setSearchWhere] = useState({
    type: props.type
  });
  // 조회 조건 할당 
  const searchWherePut = (key, val) => { setSearchWhere(prevState => ({ ...prevState, [key]: val}))};
  // Toggle 관련
  const toggle = (target) => {
    $(".tab ul li").removeClass("active");
    $(target).toggleClass("active")
  }
  // Tab 메뉴
  const tabMenu = [
    { value: 'A', name: '전체 토너먼트' },
    { value: 'S', name: '진행 중인 토너먼트' },
    { value: 'R', name: '모집 토너먼트' },
    { value: 'E', name: '예정 토너먼트' },
    { value: 'T', name: '완료 토너먼트' }
  ];
  // 상태에 따라 클래스 지정
  const bgChoice = (target) => {
    switch (target) {
      case 'S':
        return 'bg7';
      case 'R':
        return 'bg2';
      case 'E':
        return 'bg6';
      default:
        return 'bg0';
    }
  }
  // 조회
  useEffect(() => {
    Search('/tournament', setDatas, props.setDataLoading, searchWhere)
  }, [searchWhere])
  // 타이머 호출
  useEffect(() => { 
    if (!Fnc.Empty(datas)) {
      const timerDatas = datas.filter((item) => !Fnc.Empty(item.tournament_deadline_time))
      Fnc.Timer(timerDatas, setTimer)
    }
  }, [datas])
  // jQuery slick 관련
  useEffect(() => { 
  	$(".tab_slider").slick({
      autoplay:false,
      infinite:true,
      slidesToShow:9,
      slidesToScroll: 4,
      dots:false,
      arrows:true,
      focusOnSelect:true,
      pauseOnHover: false,
      prevArrow:$("#tab_prev"),
      nextArrow:$("#tab_next"),
          responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow:8,
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow:5,
          }
        },
      ]
    });
    // 현재 선택된 slick value에 접근하여 값 할당
    $(".tab_slider").on('afterChange', function (_, slick, currentSlide) {
      const currentElement = $(slick.$slides[currentSlide]);
      searchWherePut('tournament_type', currentElement.find('.items').data('value'));
    });
  }, [])

  return (
    <>
      <div className="tmt_wrap box_style1">
        <div className="tab_mu mb_30">
          <h2>Tournaments</h2>
          <div className="inner_tab">
            <div className="tab box_style1 custom-tab">
              <ul>
                {
                  tabMenu.map((item, index) => (
                    <li
                      className={index === 0 ? 'active' : null}
                      key={index}
                      onClick={
                        (e) => { 
                          toggle(e.currentTarget);
                          searchWherePut('tournament_state', item.value);
                        } 
                      }
                    >
                      {item.name}
                    </li>
                  )) 
                }
              </ul>
            </div>
          </div>
        </div>
        <div className="tab_slide box_style2">
          <span className="btn_prev" id="tab_prev"><img src={BtnPrev} alt="btn_prev"/></span>
          <span className="btn_next" id="tab_next"><img src={BtnNext} alt="btn_next"/></span>
          <div className="tab_slider">
            <div className="items" data-value="A">
              <div>
                <span>
                  <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440.556 1428.141">
                    <path className="brand_icon" d="M542.683,0H113.841C51.073,0,0,51.045,0,113.797v428.86c0,62.752,51.073,113.825,113.841,113.825h428.842c62.752,0,113.811-51.073,113.811-113.825V113.797c0-62.752-51.059-113.797-113.811-113.797ZM535.989,535.977H120.505V120.505h415.484v415.473Z" />
                    <path className="brand_icon" d="M897.842,0c-62.768,0-113.841,51.045-113.841,113.797v428.86c0,62.752,51.073,113.825,113.841,113.825h428.842c62.782,0,113.872-51.073,113.872-113.825V113.797c0-62.752-51.09-113.797-113.872-113.797h-428.842ZM1320.051,535.977h-415.546V120.505h415.546v415.473Z" />
                    <path className="brand_icon" d="M542.683,771.663H113.841c-62.768,0-113.841,51.04-113.841,113.792v428.828c0,62.785,51.073,113.858,113.841,113.858h428.842c62.752,0,113.811-51.073,113.811-113.858v-428.828c0-62.752-51.059-113.792-113.811-113.792ZM535.989,1307.636H120.505v-415.468h415.484v415.468Z" />
                    <path className="brand_icon" d="M897.842,1428.141h428.842c62.782,0,113.872-51.073,113.872-113.858v-428.828c0-62.752-51.09-113.792-113.872-113.792h-428.842c-62.768,0-113.841,51.04-113.841,113.792v428.828c0,62.785,51.073,113.858,113.841,113.858ZM904.505,892.168h415.546v415.468h-415.546v-415.468Z" />
                  </svg>
                </span>
                <p>All</p>
              </div>
            </div>
            <div className="items" data-value="C">
              <div>
                <span>
                  <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1693.525 1690.635">
                    <path className="brand_icon" d="M185.089,1301.857L350.322,172.69c2.886-19.668,7.797-38.984,14.666-57.646l-161.864,8.215C85.103,129.253-5.702,229.775.279,347.797l57.855,1139.719c5.772,113.712,99.581,202.989,213.437,203.12,3.696,0,7.392-.091,11.114-.274l435.807-22.123-292.423-42.797c-155.791-22.985-263.587-167.741-240.98-323.584Z" /><path className="brand_icon" d="M1651.082,210.107c-33.786-45.618-84.432-75.838-140.628-83.909L663.588,2.286c-116.925-17.121-225.596,63.797-242.704,180.735l-165.233,1129.153c-15.972,116.637,64.411,224.577,180.735,242.691l846.878,123.925c116.637,15.985,224.577-64.398,242.691-180.735l165.246-1129.153c8.371-56.157-6.073-113.346-40.12-158.795ZM1254.35,952.415c-101.266,75.407-241.398,139.388-293.089,161.837-12.381,5.381-26.747,3.278-37.077-5.433-43.084-36.306-159.003-137.755-234.424-239.021-180.774-242.704,142.796-483.671,323.557-240.98,242.73-180.735,483.684,142.862,240.941,323.597h.091Z" />
                  </svg>
                </span>
                <p>CASINO</p>
              </div>
            </div>
            <div className="items" data-value="S">
              <div>
                <span>
                  <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1612.389 1719.881">
                  <path className="brand_icon" d="M403.097,503.872c76.959,0,144.745-21.008,200.722-47.815-56.83,106.928-90.881,230.705-97.638,358.352-227.228,24.393-405.407,215.025-405.407,448.629,0,250.059,203.425,456.844,453.484,456.844,77.037,0,150.833-21.703,217.019-58.011-102.677-100.656-166.632-244.023-166.632-398.833s63.955-294.817,166.632-395.474c-50.965-27.962-106.495-46.976-164.48-54.363,21.913-356.148,290.881-649.916,637.673-703.517-88.322,124-135.953,271.959-135.953,427.307v277.654c-226.125,25.443-403.097,215.576-403.097,448.393,0,250.059,203.425,456.844,453.484,456.844s453.484-206.784,453.484-456.844c0-232.818-176.972-422.95-403.097-448.393v-277.654c0-170.358,66.33-330.521,186.787-450.978L1482.091,0h-121.638c-236.662,0-451.149,96.51-606.339,252.185-40.743-39.116-171.382-151.411-351.017-151.411-212.571,0-358.024,158.391-365.058,165.136L0,302.323l38.04,36.413c7.033,6.745,152.487,165.136,365.058,165.136ZM1158.905,1111.877c-83.349,0-151.161,67.813-151.161,151.161h-100.774c0-138.906,113.03-251.936,251.936-251.936v100.774ZM554.259,1111.877c-83.349,0-151.161,67.813-151.161,151.161h-100.774c0-138.906,113.03-251.936,251.936-251.936v100.774Z"/></svg>
                </span>
                <p>SOLT</p>
              </div>
            </div>
            <div className="items" data-value="P">
              <div>
                <span>
                  <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1540.111 1540.111">
                  <path className="brand_icon" d="M309.012,1191.785c-99.49-108.005-157.452-247.795-163.578-394.513H0c6.165,185.077,79.341,361.616,205.916,496.783,24.468-23.093,79.177-78.628,103.096-102.271Z"/><path className="brand_icon" d="M245.505,1332.82c135.045,126.877,311.597,200.35,496.783,206.741v-144.609c-146.895-6.504-286.707-64.962-394.513-164.953l-102.271,102.821Z"/><path className="brand_icon" d="M1191.785,1230.549c-107.806,99.991-247.618,158.449-394.513,164.953v144.609c185.077-6.165,361.616-79.341,496.783-205.916-23.093-25.018-78.628-79.727-102.271-103.645Z"/><path className="brand_icon" d="M1394.128,797.273c-6.504,146.895-64.962,286.706-164.953,394.513,24.468,23.643,78.628,79.177,102.271,102.271,127.378-134.84,201.35-311.416,208.116-496.783h-145.434Z"/><path className="brand_icon" d="M1230.549,347.776c99.991,107.806,158.449,247.618,164.953,394.513h144.609c-6.165-185.077-79.341-361.616-205.916-496.783-25.018,23.093-79.727,78.628-103.645,102.271Z"/><path className="brand_icon" d="M1294.056,206.741C1159.012,79.865,982.459,6.391,797.273,0v144.609c146.895,6.504,286.706,64.962,394.513,164.953l102.271-102.821Z"/><path className="brand_icon" d="M145.434,742.289c6.504-146.895,64.962-286.707,164.953-394.513-24.468-23.643-78.628-79.177-102.271-102.271C80.738,380.345,6.765,556.921,0,742.289h145.434Z"/><path className="brand_icon" d="M347.776,309.012c108.005-99.49,247.795-157.452,394.513-163.578V0c-185.077,6.165-361.616,79.341-496.783,205.916,23.093,24.468,78.628,79.177,102.271,103.096Z"/><path className="brand_icon" d="M1339.968,769.781c-.303-314.78-255.407-569.884-570.188-570.188-756.584,31.066-756.31,1109.309,0,1140.375,314.78-.303,569.884-255.407,570.187-570.188h0ZM769.781,742.289c226.261,6.048,249.079,325.232,27.492,364.271v48.111c0,15.183-12.309,27.492-27.492,27.492s-27.492-12.309-27.492-27.492v-48.111c-89.543-13.46-155.799-90.35-155.881-180.899,0-15.183,12.309-27.492,27.492-27.492s27.492,12.309,27.492,27.492c.152,70.8,57.589,128.114,128.388,128.113,169.902-5.498,169.352-251.004,0-256.502-101.121.572-183.558-80.939-184.13-182.059-.516-91.295,66.3-169.02,156.638-182.212v-48.111c0-15.183,12.309-27.492,27.492-27.492s27.492,12.309,27.492,27.492v48.111c89.543,13.46,155.799,90.35,155.881,180.898,0,15.183-12.309,27.492-27.492,27.492s-27.492-12.309-27.492-27.492c-.152-70.8-57.589-128.114-128.388-128.113-169.902,5.498-169.352,251.003,0,256.502h0Z"/></svg>
                </span>
                <p>최대상금순</p>
              </div>
            </div>
            {
              !Fnc.Empty(common) && common.vendors.map((item, index) => (
                <div className="items" data-value={item.name} key={index}>
                  <div>
                    <span><img src={imgs[index]} alt={item.name} /></span>
                    <p className="uppercase">{item.name}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div> 
        <div className="tab_content">
          <div className={`${Fnc.Empty(datas) ? 'no-tournament' : null} inner_list`}>
            {
              Fnc.Empty(datas)
              ? "토너먼트가 존재하지 않아요"
              : datas.slice(0, listCount).map((data, index) => (
                <div className={`box ${data.tournament_state === 'T' ? 'tmt_end' : null}`} key={index}>
                  <div className="inner_box">
                    {
                      data.tournament_state === 'T' && (
                        <div className="inner_end_box">
                          <span>TMT End<br />종료</span>
                        </div>
                      )
                    }
                    <p><img src={Url.TournamentImgUrl + data.image} alt={data.image} /></p>
                    <div className="stit">
                      <h2>ID: {data.tournament_idx}</h2>
                      <h3>
                        {data.tournament_state !== 'T' && <span className={bgChoice(data.tournament_state)}>{data.tournament_state_name}</span>}
                        {data.tournament_name}
                      </h3>
                    </div>
                    <div className="down_btn">
                      <div className="time">
                        {Fnc.Empty(timer[data.tournament_idx]) ? `토너먼트 ${data.tournament_state_name}` : `토너먼트 ${data.tournament_state_name}: ${timer[data.tournament_idx]}`}
                      </div>
                      <div className="btns">
                      <Link 
                        to={`/tournamentDetail/${data.tournament_idx}`}
                        className='btn_basic bg0 max-width-none'
                      >
                        {data.tournament_state === 'T' ? '입상자  보기' : '자세히 보기'}
                      </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
          {
            !Fnc.Empty(datas) &&
            listCount < datas.length && (
              <div className="btns_wrap mt_30 mb_30">
                <Link className="btn_more" onClick={showMore}>더불러오기</Link>
              </div>
            )
          }
        </div>
      </div>
    </>
  )
}